import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

function Footer(props) {
    return (
        <footer className={"footer text-white text-center text-md-left"}>
            <Container fluid={props.fluid}>
                <div className="copyright">
                    &copy; {`${1900 + new Date().getYear()}, Prodeseg, by `}
                    <a href="https://www.jedai.group" target="_blank" className={"text-white"} rel="noreferrer">
                        Jed.Ai Group
                    </a>
                    .
                </div>
            </Container>
        </footer>
    );
}

Footer.defaultProps = {
    default: false,
    fluid: false,
};

Footer.propTypes = {
    default: PropTypes.bool,
    fluid: PropTypes.bool,
};

export default Footer;
